import { Center, Loader } from "@mantine/core";
import { useTranslation } from "react-i18next";

export function RoutePending() {
  const { t } = useTranslation();
  return (
    <Center h="100vh" role="status" aria-label={t("common.loading")}>
      <Loader size="xl" />
    </Center>
  );
}
